import { Component, OnInit } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  standalone: true,
  selector: 'app-pdfviewer',
  imports: [PdfViewerModule],
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.less']
})
export class PDFViewerComponent implements OnInit {

  pdfSrc = "../../../../assets/pdf/ssl-sop.pdf"
  constructor() { }

  ngOnInit(): void {
  }

}
